// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cS5-","newExpiryDate":"styles_newExpiryDate__pjU0J","footer":"styles_footer__3g5ND"};